module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadx) ? _c('div', {
    staticClass: "form-card"
  }, [_c('h3', [_vm._v("Add new product")]), _vm._v(" "), _c('h4', [_c('u', [_vm._v(_vm._s(_vm.category.business_category))])]), _vm._v(" "), (_vm.subscription_offer.products && (_vm.subscription_offer.products.service_offer_active == 1)) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h5', [_vm._v("Product Details")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.product_set_details), function(detail, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_set_details[index].title),
        expression: "product_set_details[index].title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_set_details[index].title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_set_details[index].title = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "75%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_set_details[index].detail),
        expression: "product_set_details[index].detail"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_set_details[index].detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_set_details[index].detail = $event.target.value
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('h5', [_vm._v("Other details")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Product Adddotional Details")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("ADD "), _c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', [(_vm.subscription_offer.products) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Sorry you can only add " + _vm._s(_vm.subscription_offer.products.service_offer_limit) + " product(s) on this plan")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn  sp-button-02 sp-button-sm",
    staticStyle: {
      "background-color": "#ff3c00"
    },
    attrs: {
      "to": '/purchase?upgrade=' + _vm.set_business.business_username
    }
  }, [_vm._v("Upgrade Shop")])], 1) : _c('div', [_vm._m(3)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("eg:")]), _vm._v(" Material: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Pure Leather")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Quantity"), _c('br'), _vm._v("in Stock")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Sorry no subscription details found, you cannot add products at the moment")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bcc9244"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Components/AddProduct.vue
// module id = 554
// module chunks = 0